
import { Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  combineLatest,
  debounceTime,
  distinctUntilChanged,
  fromEvent,
  map,
  merge,
  startWith,
} from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class InactivityService {
  // 2 Minuten Delay
  private inactivityDelay = 1000 * 60 * 2;

  private activityIndicatorEventNames = ['click', 'mousemove', 'keypress'];
 // Sobald Activity detected ist, emitted dieses Observable 'true'
  private isUserActiveFromEvent$ = merge(
    ...this.activityIndicatorEventNames.map(eventName => fromEvent(document, eventName))
  ).pipe(map(_ => true));

  // Wenn debounceTime ueberschritten, emitted dieses Observable 'false'
  private isUserInactiveFromEvent$ = this.isUserActiveFromEvent$.pipe(
    debounceTime(this.inactivityDelay),
    map(_ => false)
  );
  private isUserActive$ = merge(this.isUserActiveFromEvent$, this.isUserInactiveFromEvent$);

  // Beruecksichtigen, wenn der Tab/Browser inaktiv ist
  // https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API#browser_compatibility
  private isTabInactive$ = fromEvent(document, 'visibilitychange').pipe(
    map(_ => document.hidden),
    startWith(false),
    distinctUntilChanged()
  );

  private isInactive = toSignal(
    combineLatest([this.isUserActive$, this.isTabInactive$]).pipe(
      map(([isUserActive, isTabInactive]) => !isUserActive || isTabInactive),
      distinctUntilChanged()
    )
  );

  isActive(): boolean {
    return !this.isInactive();
  }
}
